import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
  lista: idTipoContrato => {
    return Vue.http.get(`/api/contratos/tiposcontrato/${idTipoContrato}/subtiposcontrato`).then(resposta => resposta.body);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/sub-tipo-contrato/servico.js